/**
 * 订单详情菜品行：退菜判定与 `return_reason` 展示（`order_detail_with_head` / `history_order/head` 的 details）。
 */

/** 订单详情菜品行退菜相关字段 */
export type OrderDetailDishReturnLike = {
    /** 是否退菜（0: 非退菜，非 0: 退菜），与 `is_return_item.data[0]` 一致 */
    is_return_item?: { data?: number[] } | { type?: 'Buffer'; data?: number[] };
    /** 退菜原因，接口字段 `return_reason` */
    return_reason?: string | null;
};

/**
 * 判断订单详情菜品行是否为退菜。
 * @param dish - 菜品行
 */
export function isOrderDetailDishReturn(dish: OrderDetailDishReturnLike): boolean {
    return (dish.is_return_item?.data?.[0] ?? 0) !== 0;
}

/**
 * 退菜原因展示文案：仅退菜行有值；无 `return_reason` 时返回「–」。
 * @param dish - 菜品行
 * @returns 展示文案；非退菜返回 null
 */
export function getOrderDetailDishReturnReasonDisplay(dish: OrderDetailDishReturnLike): string | null {
    if (!isOrderDetailDishReturn(dish)) {
        return null;
    }
    const raw = (dish.return_reason ?? '').trim();
    return raw || '–';
}
